import { render } from "./RejectedTasksHead.vue?vue&type=template&id=0f7062a7"
import script from "./RejectedTasksHead.vue?vue&type=script&lang=js"
export * from "./RejectedTasksHead.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import Morph from 'quasar/src/directives/morph/Morph.js';
import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../../../../../../../oarus-app/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QBadge,QIcon,QCard,QCardSection,QList,QItem,QItemSection});qInstall(script, 'directives', {Morph,Ripple});
